import type { Metadata } from 'next'
import { Analytics } from '@vercel/analytics/next'
import './globals.css'
import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'

export const metadata: Metadata = {
  title: 'Mohammed Ghassan Al-Rifai | Entrepreneur & Investor',
  description: 'Visionary entrepreneur supporting aspiring entrepreneurs through mentorship, investment, and strategic guidance. Expertise in business development, technology, and innovation.',
  keywords: ['entrepreneur', 'investor', 'business', 'technology', 'mentorship'],
  generator: 'v0.app',
  icons: {
    icon: [
      {
        url: '/icon-light-32x32.png',
        media: '(prefers-color-scheme: light)',
      },
      {
        url: '/icon-dark-32x32.png',
        media: '(prefers-color-scheme: dark)',
      },
      {
        url: '/icon.svg',
        type: 'image/svg+xml',
      },
    ],
    apple: '/apple-icon.png',
  },
  openGraph: {
    title: 'Mohammed Ghassan Al-Rifai | Entrepreneur & Investor',
    description: 'Visionary entrepreneur supporting aspiring entrepreneurs through mentorship, investment, and strategic guidance.',
    type: 'website',
  },
}

export const viewport = {
  themeColor: '#001a2e',
  width: 'device-width',
  initialScale: 1,
}

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode
}>) {
  return (
    <html lang="en" className="bg-background dark">
      <body className="font-sans bg-background text-foreground">
        <Navigation />
        <main style={{ paddingTop: "72px" }}>{children}</main>
        <Footer />
        {process.env.NODE_ENV === 'production' && <Analytics />}
      </body>
    </html>
  )
}
